<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <!-- header_image	"uploads/images/company/header/anoosheader_69638446cd6f4.jpeg"
          footer_image	"uploads/images/company/footer/anoosFooter_69638446ce24a.jpeg" -->
          <!-- Header -->
           <header  v-if="order?.branch?.company?.header_image" >
              <div style="width:100% !important; " class="">
                <img :src="`${getFileServerUrl}${order?.branch?.company?.header_image}`" style="width:100%; " alt="" >
              </div>
           </header>

           <main>
              <div class="page-header">
                <div v-if="!order?.branch?.company?.header_image" class="header-section d-flex justify-space-between align-start">
                  <div  class="company-info">
                    <h4 class="company-name">
                      {{ order.branch?.company?.name }}
                    </h4>
                    <p class="company-text">
                      {{ order.branch?.company?.address }}
                    </p>
                    <p class="company-text">
                      <v-icon size="small">mdi-phone-outline</v-icon>
                      {{ order.branch?.company?.mobile }}
                    </p>
                    <p class="company-text">
                      <v-icon size="small">mdi-email-outline</v-icon>
                      {{ order.branch?.company?.email }}
                    </p>
                    <p v-if="order.branch?.company?.website" class="company-text">
                      <v-icon size="small">mdi-web</v-icon>
                      {{ order.branch?.company?.website }}
                    </p>
                  </div>
                  <div class="logo-container">
                    <v-img
                      :src="`${getFileServerUrl}/${order.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                      max-width="150"
                      max-height="70"
                      contain
                    />
                  </div>
                </div>

                <div class="text-center my-6" style="text-align: center !important;">
                  <h2 class="report-title">Proforma Invoice Details</h2>
                </div>
              </div>

              <div class="master-box " style=" font-size:13px; margin-top:16px !important;">
                <v-row>
                  <v-col cols="6">
                      <div >
                        <table style="width:100%; border-collapse:collapse; font-size:12px;">
                          <tbody>
                          <tr>
                            <td style="border:1px solid #000; padding:4px;"><strong>INVOICE DATE</strong></td>
                            <td style="border:1px solid #000; padding:4px;">{{ formatDate(order.invoice_date) }}</td>
                          </tr>
                          <tr>
                            <td style="border:1px solid #000; padding:4px;"><strong>SEASON</strong></td>
                            <td style="border:1px solid #000; padding:4px;">{{ order.season || '-' }}</td>
                          </tr>
                          <tr>
                            <td style="border:1px solid #000; padding:4px; "><strong>Department</strong></td>
                            <td style="border:1px solid #000; padding:4px; ">{{ formatDate(order.department) }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                  </v-col>

                  <v-col cols="6" >
                    <div >
                      <table style="width:100%; border-collapse:collapse; font-size:12px;">
                        <tbody>
                        <tr>
                          <td style="border:1px solid #000; padding:4px;"><strong>PROFORMA INVOICE NO</strong></td>
                          <td style="border:1px solid #000; padding:4px;">{{ order.proforma_invoice_no }}</td>
                        </tr>
                        <tr>
                          <td style="border:1px solid #000; padding:4px;"><strong>MASTER SALES CONTACT NO</strong></td>
                          <td style="border:1px solid #000; padding:4px;">{{ order.master_sales_contact_no || '-' }}</td>
                        </tr>
                        <tr>
                          <td style="border:1px solid #000; padding:4px; "><strong>PO NO</strong></td>
                          <td style="border:1px solid #000; padding:4px; ">{{ order.purchase_order_no }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">  
                      <div style=" height:110px; border:1px solid #000; padding:8px;"  class="mt-top">
                        <strong>SUPPLIER:</strong><br/>
                        {{ order.branch?.company?.name || '-' }}<br/>
                        {{ order.branch?.company?.address || '-' }}<br/>
                        Email: {{ order.branch?.company?.email || '-' }}<br/>
                        Phone: {{ order.branch?.company?.phone || '-' }}
                      </div>
                  </v-col>

                    <v-col cols="6" >    
                      <div style=" height:110px; border:1px solid #000; padding:8px;"  class="mt-top">
                        <strong>BUYER:</strong><br/>
                        {{ order.buyer?.company_name || '-' }}<br/>
                        {{ order.buyer?.company_address || '-' }}<br/>
                        Email: {{ order.buyer?.company_email || '-' }}
                      </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">    
                      <div style=" height:170px; border:1px solid #000; padding:8px;"  class="mt-top">
                        <strong> BENEFICIARY:</strong><br/>
                        {{ order.branch?.company?.name || '-' }}<br/>
                        {{ order.branch?.company?.address || '-' }}<br/>
                        Email: {{ order.branch?.company?.email || '-' }}<br/>
                        Phone: {{ order.branch?.company?.phone || '-' }}
                      </div>
                  </v-col>

                    <v-col cols="6" >    
                      <div style=" height:170px; border:1px solid #000; padding:8px;"  class="mt-top">
                        <strong> BENEFICIARY'S BANK:</strong><br/>
                        
                            Bank Name:
                            {{ order.beneficiary_bank?.name || '-' }}<br/>
                            Bank Address
                            {{ order.beneficiary_bank?.address || '-' }}<br/>
                            Branch:
                            {{ order.beneficiary_bank?.branch || '-' }}<br/>
                            Swift Code: 
                            {{ order.beneficiary_bank?.swift_code || '-' }}<br/>
                            A/C No:
                            {{ order.beneficiary_bank?.account_no || '-' }}<br/>
                            A/C Name:
                            {{ order.beneficiary_bank?.account_name || '-' }}<br/>
                            Routing No:
                            {{ order.beneficiary_bank?.routing_no || '-' }}<br/>
                      </div>
                    </v-col>
                </v-row>
              </div>
              <!-- Breakdown Table -->
              <br>
              <table class="dep-table order-table " style="">
                <thead>
                  <tr>
                    <th>Order Number</th>
                    <th>Style Number</th>
                    <th>Description</th>
                    <th>HS Code</th>
                    <th>Composition</th>
                    <th>Color Name</th>
                    <th>Size Range</th>
                    <th class="text-right">Quantity</th>
                    <th class="text-right">Unit Price</th>
                    <th >Currency</th>
                    <th class="text-right">Total Amount</th>
                    <th class="text-center">Cargo Receiving Date</th>
                    <th class="text-center">ETD Date</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(row, i) in order.breakdowns" :key="row.id">
                    <td>{{ row.po }}</td>
                    <td>{{ row.style_number }}</td>
                    <td>{{ row.description }}</td>
                    <td>{{ row.hs_code }}</td>
                    <td>{{ row.composition }}</td>
                    <td>{{ row.color_name }}</td>
                    <td>{{ row.size_range }}</td>
                    <td class="text-right">{{ row.quantity }}</td>
                    <td class="text-right">{{ row.unit_price }}</td>
                    <td>{{ row.currency?.code }}</td>
                    <td class="text-right">{{ row.total_amount }}</td>
                    <td class="text-center">{{ formatDate(row.cargo_receiving_date) }}</td>
                    <td class="text-center">{{ formatDate(row.etd_date) }}</td>
                  </tr>

                  <!-- TOTAL ROW -->
                  <tr class="font-weight-bold">
                    <td colspan="8" class="text-right">Total</td>
                    <td class="text-right">{{ totalQuantity }}</td>
                    <td colspan="2"></td>
                    <td colspan="3"></td>
                  </tr>
                </tbody>
              </table>

              <br>
              <table class="footer-table order-table " style=" font-size:xx-small">
                <tbody>
                  <tr>
                    <th style="text-align: left;">From</th>
                    <th>{{ order.shipment_from || '-' }}</th>
                    <th style="text-align: left;">TO</th>
                    <th>{{ order.shipment_to || '-' }}</th>
                    <th style="text-align: left;">Payment Terms</th>
                    <th>{{ order.payment_terms || '-' }}</th>
                  </tr>
                  <tr>
                    <th style="text-align: left;">Shipment Mode</th>
                    <th>{{ order.shipping_mode?.name || '-' }}</th>
                    <th style="text-align: left;">Incoterm</th>
                    <th>{{ order.incoterm || '-' }}</th>
                    <th style="text-align: left;">Partial Shipment</th>
                    <th>{{ order.partial_shipment || '-' }}</th>
                  </tr>
                  <tr>
                    <th style="text-align: left;">inspaction Certificate By</th>
                    <th>{{ order.inspaction_certificate_by || '-' }}</th>
                    <th style="text-align: left;">Short/Excess Shipment</th>
                    <th>+/- {{ order.short_or_excess_shipment_percent || '-' }}%</th>
                    <th style="text-align: left;">Transhipment</th>
                    <th>{{ order.transhipment || '-' }}</th>
                  </tr>
                  <tr>
                    <th style="text-align: left;">LC Expiry Date</th>
                    <th>{{ order.lc_expiry_date || '-' }}</th>
                    <th style="text-align: left;">Port Of Loading</th>
                    <th>{{ order.loading_port?.name || '-' }}</th>
                    <th style="text-align: left;">Early Shipment</th>
                    <th>{{ order.early_shipment || '-' }}</th>
                  </tr>
                  <tr>
                    <th style="text-align: left;">Destination Of Loading</th>
                    <th>{{ order.destination_port?.name || '-' }}</th>
                    <th style="text-align: left;"></th>
                    <th></th>
                    <th style="text-align: left;"></th>
                    <th></th>
                  </tr>
                </tbody>
              </table>

              <div class="master-box " style="margin-top:16px !important; font-size:10px;">
                <br>
                <v-row class="" >
                  <v-col cols="6">    
                      <strong> TERM & CONDITION OF SHIPMENT:</strong><br/>
                      <div style=" height:120px; border:1px solid #000; padding:8px;">
                        {{ order.branch.terms_and_condition || '-' }}
                      </div>
                  </v-col>

                    <v-col cols="6" >   
                      <strong> SIGNATURE OF THE SUPPLIER:</strong><br/> 
                      <div style=" height:120px; border:1px solid #000; padding:8px;">
                        
                          
                      </div>
                  </v-col>
                </v-row>
              </div>
          </main>

          <footer v-if="order?.branch?.company?.footer_image">
            <div style="width:100% !important; "  class="logo-container">
              <img :src="`${getFileServerUrl}${order?.branch?.company?.footer_image}`" style="width:100%; " alt="" >
            </div>
          </footer>



        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="center" class="d-print-none mt-4" style="margin-top:16px !important;">
      <v-btn color="primary" prepend-icon="mdi-printer" @click="print">
        Print
      </v-btn>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();

const order = ref({
  branch: { company: {} },
  buyer: {},
  beneficiary_bank: {},
  buyer_bank: {},
  shipping_mode: {},
  breakdowns: [],
  proforma_invoice_no: "",
  invoice_date: null,
  code: "",
});

// File server URL
const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

// Format date
function formatDate(date) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-GB");
}

// Total Quantity
const totalQuantity = computed(() =>
  order.value.breakdowns.reduce((sum, r) => sum + Number(r.quantity || 0), 0)
);

// Fetch data
async function fetchDetails(id) {
  try {
    const res = await store.dispatch("getProformaInvoiceById", { id });
    if (res?.data?.data) {
      order.value = res.data.data;

      // Convert breakdown dates
      order.value.breakdowns = order.value.breakdowns.map(row => ({
        ...row,
        cargo_receiving_date: row.cargo_receiving_date ? new Date(row.cargo_receiving_date) : null,
        etd_date: row.etd_date ? new Date(row.etd_date) : null
      }));
    }
  } catch (err) {
    console.error("Error fetching order details:", err);
  }
}

function print() {
    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Cutting Report</title>
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
        <style>
            body { font-family: 'Times New Roman', serif; margin:0; padding:15px; background:white; color:#000; }
            .report-paper { width:100%; max-width:100%; margin:auto; padding:15px; background:white; }
            .header-section { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #eee; padding-bottom:10px; margin-bottom:16px; }
            .company-name { font-size:20px; font-weight:bold; text-transform:uppercase; margin:0 0 4px 0; }
            .company-text { font-size:14px; margin:2px 0; display:flex; align-items:center; }
            .logo-container img { max-height:70px; max-width:150px; }
            .report-title { font-size:20px; text-align:center; margin:16px 0; }
            .meta-box { border:1px solid #000; padding:8px; font-size:13px; margin-bottom:16px; }
            .dep-table { width:100%; border-collapse:collapse; font-size:13px; margin-bottom:24px; }
            .dep-table th, .dep-table td { border:1px solid #000; padding:6px; vertical-align:middle; }
            .dep-table th { background:#e0e0e0; text-align:center; }

            .footer-table { width:100%; border-collapse:collapse; font-size:13px; }
            .footer-table th, .footer-table td { border:1px solid #000; padding:1px; }
            .footer-table th { background:#fff; }

            .text-center { text-align:center; }
            .text-right { text-align:right; }
            .v-row { display: flex !important; flex-wrap: wrap !important; }
            .v-col-4 { flex: 0 0 33.3333% !important; max-width: 33.3333% !important; width: 33.3333% !important; box-sizing: border-box; }
            .v-col-4 div {  min-height: 60px; border-top: 1px solid #000; padding-top: 4px; }
            .v-col-6{flex:0 0 50%!important;max-width:50%!important;width:50%!important;box-sizing:border-box}
            .v-col-6 div{min-height:60px;border-top:1px solid #000;padding-top:4px;}

            .mt-4 { margin-top:16px !important; }

            body { font-family: 'Times New Roman', serif; font-size:13px; margin:0; padding:15px; background:#fff; color:#000; }
          .full-height { min-height:100vh; }
          .grey-lighten-3 { background-color:#eeeeee !important; }
          .report-paper { width:100%; max-width:100%; margin:auto; padding:15px; background:white; box-sizing:border-box; }

          .page-header { margin-bottom:16px; }
          .header-section { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #eee; padding-bottom:10px; margin-bottom:16px; }
          .company-name { font-size:20px; font-weight:bold; text-transform:uppercase; margin:0 0 4px 0; }
          .company-text { font-size:14px; margin:2px 0; display:flex; align-items:center; }
          .logo-container img { max-height:70px; max-width:1500px;}
          .report-title { font-size:20px; text-align:center; margin:16px 0; }

          .master-box { font-size:13px; margin-top:16px; }
          .master-box div { box-sizing:border-box; }

          .v-row { display:flex !important; flex-wrap:wrap !important; margin:0 -8px; }
          .v-col-6, .v-col-4 { padding:0 8px; box-sizing:border-box; }
          .v-col-6 { flex:0 0 50% !important; max-width:50% !important; width:50% !important; }
          .v-col-4 { flex:0 0 33.3333% !important; max-width:33.3333% !important; width:33.3333% !important; }
          .v-col-6 div, .v-col-4 div { min-height:60px; border-top:1px solid #000; padding-top:4px; }

          .dep-table, .footer-table { width:100%; border-collapse:collapse; font-size:13px; margin-bottom:16px; }
          .dep-table th, .dep-table td, .footer-table th, .footer-table td { border:1px solid #000; padding:6px; vertical-align:middle; box-sizing:border-box; }
          .dep-table th { background:#e0e0e0; text-align:center; }
          .footer-table th { background:#fff; text-align:left; }

          .text-center { text-align:center !important; }
          .text-right { text-align:right; }

          .footer-table { font-size:11px; }
          .master-box[style*="font-size:10px"] { font-size:10px; }

          .mt-top{margin-top:16px !important;}

          header, footer { width:100%; display:block; }
          @media print { 
            header { position:fixed; top:0; left:0; right:0; } 
            footer { position:fixed; bottom:0; left:0; right:0; } 
            .report-paper { margin-top:150px; margin-bottom:100px; } 
            thead { display:table-header-group; } 
          }



          @media print {
              body { -webkit-print-color-adjust:exact; print-color-adjust:exact; background:#fff; color:#000; margin:0; padding:0; }
              .d-print-none { display:none !important; }
              .page-header { display:table-header-group; text-align:left; }
              .dep-table thead { display:table-header-group; }
              .master-box, .dep-table, .footer-table { page-break-inside:avoid; }
              .logo-container img { max-height:70px; max-width:150px; }
              .text-center { text-align:center !important; }
              .text-right { text-align:right; }
          }

            @media print {
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              .page-header { display:table-header-group; }
              .dep-table thead { display:table-header-group; }
            }
        </style>
        </head>
        <body>
        ${printContent}
        </body>
        </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => printWindow.print(), 500);
}

onMounted(() => {
  const id = route.params.id;
  if (id) fetchDetails(id);
});
</script>

<style scoped>
.full-height { min-height: 100vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background:white; }
.company-name { font-size:20px; font-weight:bold; text-transform:uppercase; }
.company-text { font-size:14px; }
.report-title { font-size:20px; text-align:center; margin:16px 0; }
.meta-box { border:1px solid #000; padding:8px; font-size:13px; margin-bottom:16px; }
.dep-table { width:100%; border-collapse:collapse; font-size:13px; }
.dep-table th, .dep-table td { border:1px solid #000; padding:6px; }
.dep-table th { background:#e0e0e0; }

.footer-table { width:100%; border-collapse:collapse; font-size:13px; }
.footer-table th, .footer-table td { border:1px solid #000; padding:1px; }
.footer-table th { background:#fff; }

.text-center { text-align:center; }
.text-right { text-align:right; }
</style>
